import { inject, Injectable } from '@angular/core';
import {
	Claim_StatusesClient,
	Lead_StatusesClient,
	PagedDataDtoOfClaimStatusListDto,
	PagedDataDtoOfLeadStatusListDto,
	PagedRequestDto,
} from './api.service';
import { LeadStatusesStore } from 'app/store/lead-status.store';
import { ClaimStatusesStore } from 'app/store/claim-status.store';
import { combineLatest, Observable, tap } from 'rxjs';

@Injectable({
	providedIn: 'root',
})
export class InitAppService {
	private readonly _Claim_StatusesClient = inject(Claim_StatusesClient);
	private readonly _Lead_StatusesClient = inject(Lead_StatusesClient);

	private readonly _claimStatusesStore = inject(ClaimStatusesStore);
	private readonly _leadStatusesStore = inject(LeadStatusesStore);

	constructor() {}

	init(): Observable<
		[PagedDataDtoOfClaimStatusListDto, PagedDataDtoOfLeadStatusListDto]
	> {
		const dto = PagedRequestDto.fromJS({
			pageSize: 25,
			page: 0,
			sort: 'order',
			sortDirection: 'asc',
		});

		return combineLatest([
			this._Claim_StatusesClient.getClaimStatusList(dto),
			this._Lead_StatusesClient.getLeadStatusList(dto),
		]).pipe(
			tap(
				([claimStatuses, leadStatuses]: [
					PagedDataDtoOfClaimStatusListDto,
					PagedDataDtoOfLeadStatusListDto
				]) => {
					this._claimStatusesStore.initializeClaimStatuses(
						claimStatuses?.records ?? []
					);
					this._leadStatusesStore.initializeLeadStatuses(
						leadStatuses?.records ?? []
					);
				}
			)
		);
	}
}
